import styled from 'styled-components'

export const EmailIconBubble = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  background: ${({ theme }) => theme.colors.neutralW100};
  border-radius: 100%;
`
